<div>
    <div>
        <app-equilibrar-prepaid
            [(subscribers)]="this.subscribers"
            [(subscriber)]="this.subscriber"
            [(currentList)]="this.currentList"
            [(billBalanceField)]="this.billBalanceField"
            [(endDateField)]="this.endDateField"
            (updateinitializeData)="this.initializeData()">
        </app-equilibrar-prepaid>
    </div>
    <div>
        <app-payment-options
            [(cr)]="this.cr"
            [(accountType)]="this.accountType"
            [(accountSubtype)]="this.accountSubtype"
            [(type)]="this.type"
            [(token)]="this.token"
            [(selectBan)]="this.selectBan" 
            [(billBalanceField)]="this.billBalanceX"
            [(paperless)]="this.paperless"
            (updateBillBalanceField)="this.billBalanceX=$event">
        </app-payment-options>    
    </div>
</div>